module.exports = __webpack_public_path__ + "img/title.577e4d7b.png";